import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import './modules/side-panel-sdo';
import './modules/side-panel-button';
import './modules/side-panel-offcanvas-button';

/**
 * @summary SidePanel
 * @extends {AoflElement}
 */
@customElement('side-panel')
class SidePanel extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of SidePanel.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'side-panel';

  panelLocation = this.hasAttribute('right')? 'right': 'left'; // eslint-disable-line no-invalid-this
  mobileMediaQuery = window.matchMedia('(max-width: 767px)');
  @property({type: Boolean})
  sidePanelActive = false;

  @property({type: Boolean})
  right = false;

  @property({type: Boolean})
  ['off-canvas'] = false;

  mobileMediaQueryHandler = (e) => {
    const commitPayload = {
      namespace: 'sidePanels',
      mutationId: 'set' + this.panelLocation.charAt(0).toUpperCase() + this.panelLocation.slice(1) + 'Active' // eslint-disable-line no-invalid-this
    };
    this.storeInstance.commit({ // eslint-disable-line no-invalid-this
      ...commitPayload,
      payload: false
    });
  };

  offCanvasHandler = () => {
    this.storeInstance.commit({ // eslint-disable-line no-invalid-this
      namespace: 'sidePanels',
      mutationId: 'set' + this.panelLocation.charAt(0).toUpperCase() + this.panelLocation.slice(1) + 'Active', // eslint-disable-line no-invalid-this
      payload: false
    });
    window.removeEventListener('click', this.offCanvasHandler); // eslint-disable-line no-invalid-this
    window.removeEventListener('keydown', this.offCanvasHandler); // eslint-disable-line no-invalid-this
  };

  escapeClose = (e) => {
    if (e.key === 'Escape') {
      this.offCanvasHandler();
      this.dispatchEvent(new CustomEvent('on-left-panel-close-by-key', {
        bubbles: true,
        composed: true
      }));
    }
  };

  /**
   *
   */
  connectedCallback() {
    super.connectedCallback();
    this.openClass = 'open-' + this.panelLocation;
    this.closeClass = 'close-' + this.panelLocation;

    this.mobileMediaQuery.addListener(this.mobileMediaQueryHandler);
    this.addEventListener('click', this.clickHandler);
  }

  mapStateProperties() {
    const state = this.storeInstance.getState();
    this['off-canvas'] = this.mobileMediaQuery.matches? true: state.sidePanels[this.panelLocation].offCanvas;


    if (this['off-canvas']) {
      this.setAttribute('off-canvas', '');
      this.sidePanelActive = state.sidePanels[this.panelLocation].active;
      if (this.sidePanelActive === true) {
        window.addEventListener('click', this.offCanvasHandler);
        window.addEventListener('keydown', this.escapeClose);
      } else {
        window.removeEventListener('click', this.offCanvasHandler);
        window.removeEventListener('keydown', this.escapeClose);
      }
    } else {
      this.removeAttribute('off-canvas');
      this.sidePanelActive = true;
    }
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.mobileMediaQuery.removeListener(this.mobileMediaQueryHandler);
    window.removeEventListener('click', this.offCanvasHandler);
    this.removeEventListener('click', this.clickHandler);
  }
}

export default SidePanel;
